const main = () => {
    // PC版（旧フッター検索）
    document.querySelectorAll('[data-footer-rail-trigger]').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const item = trigger.closest('.l-footer-search__rail-item');
            if (!item) return;
            item.toggleAttribute('data-is-open');
        });
    });

    // SP版（旧フッター検索）
    document.querySelectorAll('[data-footer-rail-trigger-sp]').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const item = trigger.closest('.l-footer-search-sp__rail-item');
            if (!item) return;
            item.toggleAttribute('data-is-open');
        });
    });

    // フッター「エリア・駅沿線から探す」SPアコーディオン（Figma 4918:17190）
    document.querySelectorAll('[data-footer-area-station-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
            // PCは常時展開のためトグルしない
            if (window.matchMedia('(min-width: 769px)').matches) return;
            const col = trigger.closest('.l-footer__area-station-col');
            if (!col) return;
            const open = col.classList.toggle('is-open');
            trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    });

    // 沿線クリックで駅一覧を展開（PC/SP共通）
    document.querySelectorAll('[data-footer-rail-expand]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const item = trigger.closest('.l-footer__area-station-rail');
            if (!item) return;
            const open = item.classList.toggle('is-open');
            trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    });
};
export default main;
